import { Schema } from './schemas'

export type Subject = keyof typeof Schema

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Subjects = Object.fromEntries(Object.entries(Schema).map(([key, value]) => [key, key])) as unknown as {
  [key in Subject]: key
}

export const SubjectOptions: Subject[] = Object.values(Subjects)

export function isSubject(input: unknown): input is Subject {
  return SubjectOptions.includes(input as any)
}

export function assertIsSubject(input: unknown): asserts input is Subject {
  if (!isSubject(input)) {
    throw new Error(`"${input}" is not a subject`)
  }
}
